// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColorInput {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.ColorInput-Swatches {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.ColorInput-Swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
}
.ColorInput-Swatch.active {
  border-color: var(--bs-dark);
}
.ColorInput-Swatch:focus-visible {
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
}
.ColorInput-Separator {
  color: var(--bs-gray-400);
}
.ColorInput-CustomLabel {
  font-size: 0.85rem;
  color: var(--bs-gray-600);
}
.ColorInput-Input {
  width: 36px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.25rem;
  cursor: pointer;
  background: none;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/common/ColorInput/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;AAAJ;AAEI;EACE,4BAAA;AAAN;AAGI;EACE,oCAAA;EACA,mBAAA;AADN;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,kBAAA;EACA,yBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALJ","sourcesContent":[".ColorInput {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n\n  &-Swatches {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  &-Swatch {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    padding: 0;\n    cursor: pointer;\n\n    &.active {\n      border-color: var(--bs-dark);\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--bs-primary);\n      outline-offset: 2px;\n    }\n  }\n\n  &-Separator {\n    color: var(--bs-gray-400);\n  }\n\n  &-CustomLabel {\n    font-size: 0.85rem;\n    color: var(--bs-gray-600);\n  }\n\n  &-Input {\n    width: 36px;\n    height: 28px;\n    padding: 0;\n    border: 1px solid var(--bs-gray-300);\n    border-radius: 0.25rem;\n    cursor: pointer;\n    background: none;\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
